<template>
  <div>


    <fieldset>
      <h2>Waterplanten</h2>
      <p>Geef per groep waterplanten de bedekking aan. Voor elke groep worden de volgende categorieën gebruikt:</p>
	  <img src="/app/themes/natuur-en-milieu/campagnes/watermonsters/assets/images/schema_hoeveelheid.jpg" alt="" class="categories_image">

		<ImageRadio
			:key="plants[0].key"
			:name="plants[0].key"
			:title="plants[0].name"
			v-model="localMeasurement[plants[0].key]"
			:img="plants[0].img"
		/>
		<ImageRadio
			:key="plants[1].key"
			:name="plants[1].key"
			:title="plants[1].name"
			v-model="localMeasurement[plants[1].key]"
			:img="plants[1].img"
		/>

		<ImageInput 
			v-model="localMeasurement.photoAlgea" 
			label="Foto Algen" name="photo_algea" 
			subtitle="Maak een foto maken van de algen. Dan kunnen wij zien om welke soort het gaat." 
			v-if="localMeasurement[plants[1].key] && localMeasurement[plants[1].key] !== 'geen'">
		</ImageInput>
		
		<ImageRadio
			:key="plants[2].key"
			:name="plants[2].key"
			:title="plants[2].name"
			v-model="localMeasurement[plants[2].key]"
			:img="plants[2].img"
		/>
		<ImageRadio
			:key="plants[3].key"
			:name="plants[3].key"
			:title="plants[3].name"
			v-model="localMeasurement[plants[3].key]"
			:img="plants[3].img"
		/>
    </fieldset>
    <nav>
      <button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
      <button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">Volgende</button>
    </nav>
  </div>
</template>

<script>
import ImageRadio from "./components/ImageRadio";
import FormStep from "./FormStep.vue";
import ImageInput from "./components/ImageInput.vue";

export default {
  name: "FormStep8",
	components: {ImageRadio, ImageInput},
	data() {
		const imgPrefix = '/app/themes/natuur-en-milieu/campagnes/watermonsters/assets/images/';
		return {
			plants: [
				{
					name: 'Kroos',
					key: 'plantDuckweed',
					img: imgPrefix+'kroos_omcirkeld.jpg',
				},
				{
					name: 'Drijvende algen',
					key: 'plantFloatingAlgae',
					img: imgPrefix+'drijvende_algen.jpg',
				},
				{
					name: 'Drijvende planten',
					key: 'plantFloatingPlants',
					img: imgPrefix+'drijvende_planten.jpg',
				},
				{
					name: 'Onderwater planten',
					key: 'plantUnderwater',
					img: imgPrefix+'onderwater_planten.jpg',
				},
			],
			fieldRequirements: {
				plantDuckweed: ['required'],
				plantFloatingAlgae: ['required'],
				plantFloatingPlants: ['required'],
				plantUnderwater: ['required'],
			}
		}
	},
  mixins: [FormStep],
}
</script>

<style scoped>
	.categories_image {
		max-width: 100%;
		height: auto;
		margin-bottom: 43px;
	}
</style>
